"use strict";

module.exports = /* @ngInject */ function(
  $q,
  openFinWindowUtils,
  sideBySideApi,
  eikonUsageCheck
) {
  function RediWindow(menuItem) {
    this.menuItem = menuItem;
    this.windowInstance = null;
    this.name = null;
    this.windowInstanceName = null;
  }

  function isEikonMessenger(menuItem) {
    return menuItem.getType() === "EikonMessenger";
  }

  RediWindow.prototype.isEikonContainedMessenger = function() {
    var that = this;
    return eikonUsageCheck
      .isUsingEikonLight()
      .then(function(isUsingEikonLight) {
        return isEikonMessenger(that) && isUsingEikonLight;
      });
  };

  RediWindow.prototype.setWindowInstance = function(windowValue) {
    var that = this;
    this.windowInstance = windowValue;
    return that.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        that.windowInstanceName = that.windowInstance.name;
      } else {
        that.windowInstanceName = that.windowInstance.instanceId;
      }
    });
  };

  RediWindow.prototype.getPath = function() {
    return this.menuItem.url;
  };

  RediWindow.prototype.isAlwaysOpen = function() {
    return !!(this.menuItem.hideOnClose || this.menuItem.alwaysOpen);
  };

  RediWindow.prototype.isBackground = function() {
    return !!this.menuItem.background;
  };

  RediWindow.prototype.isREDIPlusWindow = function() {
    return this.menuItem.platform === "REDIPlus";
  };

  RediWindow.prototype.isEikonWindow = function() {
    return this.menuItem.platform === "Eikon";
  };

  RediWindow.prototype.isGoldmanWindow = function() {
    var GOLDMAN_DOMAIN = ".gs.com";
    return this.menuItem.url.includes(GOLDMAN_DOMAIN);
  };

  RediWindow.prototype.isSymphonyWindow = function() {
    var SYMPHONY_DOMAIN = ".symphony.com";
    return this.menuItem.url.includes(SYMPHONY_DOMAIN);
  };

  RediWindow.prototype.isCaptronWindow = function() {
    var CAPTRON_DOMAIN = ".captron.co";
    return this.menuItem.url.includes(CAPTRON_DOMAIN);
  };

  RediWindow.prototype.isEikonContainer = function() {
    var that = this;
    return eikonUsageCheck
      .isUsingEikonLight()
      .then(function(isUsingEikonLight) {
        // In context of checking if the window is Eikon container
        // facing a risk of changing the behavior without extensive automated test suite
        // we decided to keep the previous behavior of returning false for Eikon Messenger
        // to achieve stability
        // accepting that this behavior might not be necessary to keep
        return (
          isUsingEikonLight && !!that.isEikonWindow() && !isEikonMessenger(that)
        );
      });
  };

  RediWindow.prototype.isOpenfinContainer = function() {
    return this.isEikonContainer().then(function(isEikonContainer) {
      return !isEikonContainer;
    });
  };

  RediWindow.prototype.onlyAllowsOpeningOneWindow = function() {
    return this.menuItem.maxNumberOfWindows === 1;
  };

  RediWindow.prototype.getSubDomain = function() {
    return this.menuItem.subDomain;
  };

  RediWindow.prototype.shouldShowFrame = function() {
    return (
      this.isEikonWindow() ||
      this.isGoldmanWindow() ||
      this.isSymphonyWindow() ||
      this.isCaptronWindow()
    );
  };

  RediWindow.prototype.getType = function() {
    return this.menuItem.type;
  };

  RediWindow.prototype.getName = function() {
    return this.name;
  };

  RediWindow.prototype.setName = function(name) {
    this.name = name;
  };

  RediWindow.prototype.getDefaultWindowSize = function() {
    return this.menuItem.defaultWindowSize;
  };

  RediWindow.prototype.getMinWindowSize = function() {
    return this.menuItem.minWindowSize;
  };

  RediWindow.prototype.onClosed = function(onClosedCallBack) {
    var that = this;
    return this.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        that.windowInstance.addEventListener("closed", onClosedCallBack);
      } else {
        sideBySideApi.onWindowClosed(that.getInstanceName(), onClosedCallBack);
      }
    });
  };

  RediWindow.prototype.show = function() {
    var that = this;
    return this.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        return openFinWindowUtils.show(that.windowInstance);
      }
    });
  };

  RediWindow.prototype.setLayout = function(layout) {
    var that = this;
    return this.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        return openFinWindowUtils
          .setBounds(that.windowInstance, layout)
          .then(function(openFinWindow) {
            return openFinWindowUtils.setState(openFinWindow, layout.state);
          });
      }
    });
  };

  RediWindow.prototype.setState = function(state) {
    var that = this;
    return this.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        return openFinWindowUtils.setState(that.windowInstance, state);
      }
    });
  };

  RediWindow.prototype.getBounds = function() {
    var that = this;
    return this.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        return openFinWindowUtils.getBounds(that.windowInstance);
      }
    });
  };

  RediWindow.prototype.getState = function() {
    var that = this;
    return this.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        return openFinWindowUtils.getState(that.windowInstance);
      }
    });
  };

  RediWindow.prototype.getLayout = function() {
    var that = this;
    return this.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        return openFinWindowUtils.getLayout(that.windowInstance);
      }
    });
  };

  RediWindow.prototype.restoreIfMinimized = function() {
    var that = this;
    return this.isOpenfinContainer().then(function(isOpenfinContainer) {
      if (isOpenfinContainer) {
        return openFinWindowUtils.restoreIfMinimized(that.windowInstance);
      }
    });
  };

  RediWindow.prototype.getInstanceName = function() {
    return this.windowInstanceName;
  };

  RediWindow.prototype.getNativeId = function() {
    var that = this;
    return this.isEikonContainer().then(function(isEikonContainer) {
      if (isEikonContainer) {
        return that.windowInstance.hWnd;
      } else {
        return openFinWindowUtils.getNativeId(that.windowInstance);
      }
    });
  };

  return RediWindow;
};



// WEBPACK FOOTER //
// ./app/infrastructure/models/RediWindow.js